import { useEffect,useState } from "react";
import { createPortal } from "react-dom";
import { FaCheck, FaTimes } from "react-icons/fa";
import Edit from "../../assets/images/edit.svg";
import CreateNFCAlbum from '../../apis/createNFCAlbum/createNFCAlbum';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const EditableAlbumCell = ({ rowData, onSave }) => {
  const [image, setImage] = useState(null);
    const [imageName, setImageName] = useState('');
    const fetchImageAsFile = async (imageUrl) => {
      try {
        const response = await fetch(imageUrl);
        if (!response.ok) throw new Error('Failed to fetch image');
  
        const blob = await response.blob();
  
        const urlParts = imageUrl.split('/');
        let filename = urlParts[urlParts.length - 1].split('?')[0];
  
        filename = filename.replace(/\d+_*/g, '');
        filename = filename.replace(/^[^\w]+|[^\w]+$/g, '');
        filename = filename || 'image.jpg';
  
        const file = new File([blob], filename, { type: blob.type });
        return file;
      } catch (error) {
        console.error('Error fetching image as file:', error);
        return null;
      }
    };
    useEffect(() => {
  
      if (rowData) {
        if (rowData.albumPic) {
          fetchImageAsFile(rowData.albumPic)
            .then(file => {
              setImage(file);
              setImageName(file.name);
            })
            .catch(error => console.error('Error converting image:', error));
        }
      }
  
  
    }, [rowData]);
  const [showPopup, setShowPopup] = useState(false);
  const [newTitle, setNewTitle] = useState(rowData.title);
const [isLoading, setLoading] = useState(false);
  const handleSave = async (e) => {
   
    if (newTitle.trim() !== "") {

      setLoading(true);

      const formData = new FormData();
      formData.append('Title', newTitle);
      formData.append('Description', rowData.description);
      formData.append('SpecialMessage', rowData.specialMessage);
      formData.append('isPublicLibrary', rowData.isPublicLibrary);
      if (image) formData.append('AlbumCover', image);

      if (rowData.eventUrl) {
        formData.append('EventUrl', rowData.eventUrl);
      }
      else {
        formData.append('EventUrl', 'album');
      }
      if (rowData.id) {
        formData.append('AlbumId', rowData.id);
        formData.append('FolderName', rowData.albumPic)
        if (image) {
          formData.append('IsPicChanged', true);
          formData.append('AlbumCover', image);
          
        } else {
          formData.append('IsPicChanged', false);
          
        }
      }
      else{
        formData.append('FolderName', '')
      }
      console.log("FormData entries:");
      for (let [key, value] of formData.entries()) {
        console.log(key, value);
      }

      try {
        const authenticationToken = sessionStorage.getItem('token');
        const response = await CreateNFCAlbum(authenticationToken, formData);
        if (response.result === 1 && response.errorValue === null) {

          if (rowData.title) {
            toast.success('Title successfully updated!');
            setTimeout(() => {
              setShowPopup(false);

            }, 1000);
          }

        } else if (response.result === 0 && response.errorValue && response.errorValue.errorCode === 103) {
          console.error('Invalid authentication token:', response.errorValue.errorText);
          sessionStorage.clear();

        } else {
          console.error('API call returned an error:', response);
        }
      } catch (error) {
        console.error('API call error:', error);
      } finally {
        setLoading(false);
      }

    }
  };

  const handleCancel = () => {
    setNewTitle(rowData.title);
    setShowPopup(false);
  };

  // modal UI
  const modal = (
    <div className="album-modal-overlay" onClick={handleCancel}>
      <div className="album-modal" onClick={(e) => e.stopPropagation()}>
        <h3>Edit Album Name</h3>
        <input
          type="text"
          value={newTitle}
          onChange={(e) => setNewTitle(e.target.value)}
          className="album-input"
          autoFocus
        />
        <div className="album-actions">
          <FaCheck
            className="album-action-icon"
            style={{ color: "green" }}
            onClick={handleSave}
          />
          <FaTimes
            className="album-action-icon"
            style={{ color: "red" }}
            onClick={handleCancel}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="album-cell">
      <span className="album-titles">{rowData.title}</span>
      <img
        src={Edit}
        alt="Edit"
        className="album-edit-icon"
        width={15}
        height={15}
        disabled={isLoading}
        onClick={() => setShowPopup(true)}
      />

      {showPopup && createPortal(modal, document.body)}
    </div>
    
  );
  <ToastContainer />
};

export default EditableAlbumCell;
